/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setMenuAssignment} from '../api'

export const useMutationSetMenuAssignment = createReactQueryMutationHook('setMenuAssignment', setMenuAssignment)
